const discountsActionTypes = {
  FETCH_DISCOUNTS_LIST: 'FETCH_DISCOUNTS_LIST',
  FETCH_DISCOUNTS_LIST_SUCCESS: 'FETCH_DISCOUNTS_LIST_SUCCESS',
  FETCH_DISCOUNTS_LIST_FAIL: 'FETCH_DISCOUNTS_LIST_FAIL',

  SEARCH_PRODUCTS: 'SEARCH_PRODUCTS',
  SEARCH_PRODUCTS_SUCCESS: 'SEARCH_PRODUCTS_SUCCESS',
  SEARCH_PRODUCTS_FAIL: 'SEARCH_PRODUCTS_FAIL',

  CREATE_DISCOUNT: 'CREATE_DISCOUNT',
  CREATE_DISCOUNT_SUCCESS: 'CREATE_DISCOUNT_SUCCESS',
  CREATE_DISCOUNT_FAIL: 'CREATE_DISCOUNT_FAIL',

  UPDATE_DISCOUNT: 'UPDATE_DISCOUNT',
  UPDATE_DISCOUNT_SUCCESS: 'UPDATE_DISCOUNT_SUCCESS',
  UPDATE_DISCOUNT_FAIL: 'UPDATE_DISCOUNT_FAIL',

  FETCH_OFFERS_PRODUCTS: 'FETCH_OFFERS_PRODUCTS',
  FETCH_OFFERS_PRODUCTS_SUCCESS: 'FETCH_OFFERS_PRODUCTS_SUCCESS',
  FETCH_OFFERS_PRODUCTS_FAIL: 'FETCH_OFFERS_PRODUCTS_FAIL',

  PERFORM_OFFER_ACTION: 'PERFORM_OFFER_ACTION',
  PERFORM_OFFER_ACTION_SUCCESS: 'PERFORM_OFFER_ACTION_SUCCESS',
  PERFORM_OFFER_ACTION_FAIL: 'PERFORM_OFFER_ACTION_FAIL',
};

export default discountsActionTypes;
